module.exports = __webpack_public_path__ + "static/media/chevron-white.1a84ea02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/chevron-white.svg
// module id = 503
// module chunks = 0